"use client"
import { createContext, useContext, useState } from "react";
import BasketModel from '../basket/model/basket';

export const Basket = createContext(undefined);

export function BasketProvider({ children }) {
    const [tempData, setTempData] = useState([]);
    const [basket, setBasket] = useState(BasketModel(setTempData, tempData));

    return (
        <Basket.Provider value={[
            basket,
            setBasket
        ]}>{children}</Basket.Provider>
    );
}